import React from "react"

export default ({name, youtubeId}) => (
  <iframe style={{width: "100%", height: 400}} title="miou" src={`https://www.youtube.com/embed/${youtubeId}?feature=oembed&showinfo=0`} frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
)

